module.exports = __webpack_public_path__ + "img/enterprise_managed.81d14176.svg";